export default () => (
  <path d="m6.83 19.64-4.5-4.92a1.31 1.31 0 0 1 0-1.74l4.5-4.9a1.06 1.06 0 0 1 1.6 0c.43.49.43 1.27 0 1.75l-2.59 2.79H17.2c.3 0 .56-.28.56-.62V5.23c0-.68.5-1.23 1.12-1.23.63 0 1.13.55 1.13 1.23V12c0 1.7-1.26 3.08-2.81 3.08H5.84l2.58 2.82a1.27 1.27 0 0 1 0 1.71c-.44.51-1.15.51-1.59.03Z" />
);
